"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tools_1 = require("../../../utils/tools");
var prosemirror_tables_1 = require("prosemirror-tables");
var prosemirror_state_1 = require("prosemirror-state");
var createAlignUtil = function (name, value, checkActive) {
    if (checkActive === void 0) { checkActive = true; }
    return /** @class */ (function () {
        function class_1() {
            this.name = name;
            this.disable = function (editor) {
                if (prosemirror_tables_1.isInTable(editor.view.state))
                    return false;
                return !(editor.view.state.selection instanceof prosemirror_state_1.AllSelection) && !tools_1.checkParentSupportAttr(editor.view, 'align');
            };
            this.active = checkActive ? function (editor) { return tools_1.checkParentHaveAttr(editor.view, 'align', value); } : function () { return false; };
            this.handler = function (editor) {
                tools_1.setAlign(editor.view, value);
                editor.focus();
            };
        }
        return class_1;
    }());
};
var AlignLeftUtil = createAlignUtil('align_left', 'left', false);
exports.AlignLeftUtil = AlignLeftUtil;
var AlignCenterUtil = createAlignUtil('align_center', 'center');
exports.AlignCenterUtil = AlignCenterUtil;
var AlignRightUtil = createAlignUtil('align_right', 'right');
exports.AlignRightUtil = AlignRightUtil;
var AlignJustifyUtil = createAlignUtil('align_justify', 'justify');
exports.AlignJustifyUtil = AlignJustifyUtil;
//# sourceMappingURL=align-util.js.map